import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            await login(email, password);
            navigate('/');
        } catch (err) {
            setError(err.response?.data?.message || 'Error al iniciar sesión');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-wrapper">
            <div className="login-container">
                {/* Lado izquierdo: imagen con epígrafe */}
                <div className="login-left">
                    <div
                        className="login-image"
                        style={{ backgroundImage: "url('/images/masaje.jpg')" }}
                    >
                        <div className="login-image-overlay">
                            <div className="login-epigraph">
                                <p>Bienvenido a Tu Masaje</p>
                                <span>Relájate y renueva tu energía</span>
                            </div>
                            {/* Nuevo epígrafe de autor */}
                            <div className="login-author">
                                {/*<span>📸 Fotografía: Unsplash / Autor</span> */}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Lado derecho: formulario centrado sobre fondo cálido */}
                <div className="login-right">
                    <div className="login-box">
                        <div className="login-header">
                            <h2>Iniciar Sesión</h2>
                            <p>Accede a tu cuenta</p>
                        </div>
                        {error && <div className="alert alert-danger">{error}</div>}
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Email</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    placeholder="ejemplo@correo.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>Contraseña</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    placeholder="********"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </div>
                            <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                                {loading ? 'Cargando...' : 'Ingresar'}
                            </button>
                        </form>
                        <div className="login-footer">
                            <Link to="/register">¿No tienes cuenta? Regístrate</Link>
                            <Link to="/forgot-password">¿Olvidaste tu contraseña?</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;